import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Stack,
    Typography,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import { MODEL_PROPTYPES } from "../../models";
import { ParcellaireHCCSaveForm } from "./ParcellaireHCCSaveForm";
import PropTypes from "prop-types";
import { useSnackbar } from "../../hooks";

// The tabs mechanism here is based on MUI's basic tab example
// https://mui.com/material-ui/react-tabs/#basic-tabs

ParcellaireHCCSaveModal.propTypes = {
    open: PropTypes.bool.isRequired,
    setIsOpen: PropTypes.func.isRequired,
    parcellaireState: PropTypes.object.isRequired,
    parcellaireDispatch: PropTypes.func.isRequired,
    setGeoJsonKey: PropTypes.func.isRequired,
    elapsedSeconds: PropTypes.number.isRequired,
    resetTimer: PropTypes.func.isRequired,
    initialCompany: PropTypes.shape(MODEL_PROPTYPES.Company),
    initialContract: PropTypes.shape(MODEL_PROPTYPES.Contract),
    initialSite: PropTypes.shape(MODEL_PROPTYPES.Site),
    initialMission: PropTypes.shape(MODEL_PROPTYPES.Mission),
    orthoimageCompany: PropTypes.shape(MODEL_PROPTYPES.Company),
    orthoimageContract: PropTypes.shape(MODEL_PROPTYPES.Contract),
    orthoimageSite: PropTypes.shape(MODEL_PROPTYPES.Site),
    orthoimageMission: PropTypes.shape(MODEL_PROPTYPES.Mission),
};

export function ParcellaireHCCSaveModal({
    open,
    setIsOpen,
    parcellaireState,
    parcellaireDispatch,
    setGeoJsonKey,
    elapsedSeconds,
    resetTimer,
    initialCompany,
    initialContract,
    initialSite,
    initialMission,
    orthoimageCompany,
    orthoimageContract,
    orthoimageSite,
    orthoimageMission,
}) {
    const { openSnackbar } = useSnackbar();
    return (
        <Dialog open={open} fullWidth maxWidth="sm">
            <DialogTitle>
                <Stack
                    direction="row"
                    sx={{ borderBottom: 1, borderColor: "divider" }}
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Typography variant="h5">Save plot map</Typography>
                    <IconButton
                        onClick={() => {
                            setIsOpen(false);
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Stack>
            </DialogTitle>
            <DialogContent sx={{ bgcolor: "background.default" }}>
                <ParcellaireHCCSaveForm
                    setIsOpen={setIsOpen}
                    parcellaireState={parcellaireState}
                    parcellaireDispatch={parcellaireDispatch}
                    setGeoJsonKey={setGeoJsonKey}
                    openSnackbar={openSnackbar}
                    initialCompany={initialCompany}
                    initialContract={initialContract}
                    initialSite={initialSite}
                    elapsedSeconds={elapsedSeconds}
                    resetTimer={resetTimer}
                    initialMission={initialMission}
                    orthoimageCompany={orthoimageCompany}
                    orthoimageContract={orthoimageContract}
                    orthoimageSite={orthoimageSite}
                    orthoimageMission={orthoimageMission}
                />
            </DialogContent>
        </Dialog>
    );
}
